module.exports = __webpack_public_path__ + "img/p8.040fa4a0.png";